/* IMPORT */
import Color from '../color/index.js';
/* MAIN */
const toRgba = (color) => {
    return Color.format.rgba.stringify(Color.parse(color));
};
/* EXPORT */
export default toRgba;
